import api from '../config/Api';

const endpoint = 'v1/attribute-media';

export default {

  getAttributes( params ) {
    return api.get( endpoint, params );
  },

  saveAttributes( data ) {
    return api.put( endpoint, data );
  },
};
